// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3ibz0","head":"ProcedureTableInfo_head__2pq44"};